// @flow
import Resource from 'speed-js-core/src/api/NestedResource';

export default class ServiceZoneNestedResource extends Resource {
    basePath: string = 'services/services/{parent}/service-zone/';

    objectPath: string = 'services/services/{parent}/service-zone/{ident}/';
}
